export default {
	name: 'with-credentials',
	req: (payload) => {
		payload.req.withCredentials = true;
		return payload;
	},
};
